import { Accepted, Cookie, Cookies, cookies, getCookie, requiredCookies, setCookie } from "./cookies";
import { DataLayer } from "./datalayer";
import { ConsentMapping, FullConsentUpdate, defaultContent as defaultConsent, gtag, updateConsentMode } from "./datalayer.consent";

const cookieToModeMapping: ConsentMapping<Cookie> = {
  'analytical-cookies': ['analytics_storage'],
  'functional-cookies': ['functionality_storage', 'security_storage'],
  'video-cookies': [],
  'tracking-cookies': ['personalization_storage', 'ad_personalization', 'ad_storage', 'ad_user_data'],
  'readspeaker-cookies': []
}

export const getCurrentCookies: () => Map<Cookie, Accepted> = () =>
  new Map(cookies.map((cookie) => [cookie, getCookie(cookie) === 'yes' || requiredCookies.includes(cookie) ? 'yes' : 'no']))

export const updateConsent = updateConsentMode(cookieToModeMapping)

export const setConsentCookie = (cookie: Cookie, isAccepted: Accepted) => {
  updateConsent(cookie, isAccepted == 'yes')
  setCookie(cookie, isAccepted, 1000)
}

export const acceptAllCookies = () => {
  // Set all configurable cookies to 'yes'
  cookies.forEach((cookie) => setConsentCookie(cookie, "yes"))
  // Fire datalayer event about accepting cookies
  DataLayer.cookies("accept");
  // Prevent cookie bar from showing again
  setCookie('showCookies', 'no', 1000)
  location.reload();
}

export const denyAllCookies = () => {
  // Set all but required configurable cookies to 'no'
  cookies.filter((cookie) => !requiredCookies.includes(cookie)).map((cookie) => setConsentCookie(cookie, 'no'))
  // Set required cookies to 'yes'
  requiredCookies.forEach((cookie) => setConsentCookie(cookie, "yes"))
  // Fire datalayer event about accepting cookies
  DataLayer.cookies("declined");
  // Prevent cookie bar from showing again
  setCookie('showCookies', 'no', 1000)
  location.reload();
}

export const acceptSelectedCookies = (selectedCookies: Cookies) => {
  // Grant selected consent types
  selectedCookies.forEach((isAccepted, cookie) => setConsentCookie(cookie, isAccepted))
  // Fire datalayer event about accepting cookies
  DataLayer.cookies("accept_partly");
  // Prevent cookie bar from showing again
  setCookie('showCookies', 'no', 1000)
  // Set required cookies to 'yes'
  requiredCookies.forEach((cookie) => setCookie(cookie, "yes", 1000))
  location.reload();
}

/**
 * Update the initial consent for Google consent mode v2
 */
export function updateInitialConsent () {
  const currentCookies = getCurrentCookies()
  const data: FullConsentUpdate = defaultConsent
  currentCookies.forEach((isAccepted, cookie) => {
    var modes = cookieToModeMapping[cookie]
    modes.forEach(mode => data[mode] = isAccepted == 'yes' ? 'granted' : 'denied')
  })
  gtag('consent', 'update', data);
}

window.updateInitialConsent = updateInitialConsent
